import { parentApi } from '../../fetcher';

export const slidesApi = parentApi.injectEndpoints({
    endpoints: (builder) => ({
        getSlides: builder.query({
            query: (city) => `${city}/slides?filter=id;restaurant_id;is_advertising;advertiser_name;advertiser_inn;advertiser_erid`,
            providesTags: ['SLIDES'],
        }),
    }),
});

export const { useGetSlidesQuery } = slidesApi;
